import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { TwoStepPaymentFormStepInterface } from 'common/types/entities/two-step-payment-form-interface'
import { useManagement, useOptIn, usePage } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import { optInRecaptchaValidationFailed } from 'publisher/store/optIn/optInActions'
import { getSubmittedRecaptchas } from 'publisher/store/optIn/optInSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { useDispatch } from 'react-redux'
import { SendFormActionButtonEntityInterface } from 'src/shared/entities/button/send-form.action-button.schema'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export const CAPTCHA_EMPTY_FIELD_ERROR = 'CAPTCHA_EMPTY_FIELD_ERROR'

export function useRecaptchaValidation(
  optInButtonEntity:
    | OldEntityInterface
    | PaymentButtonEntityInterface
    | BookingCalendarInterface
    | BookingPaidCalendarInterface
    | TwoStepPaymentFormStepInterface
    | SendFormActionButtonEntityInterface,
) {
  const captchaOpenKey = useManagement(managementSelectors.getCaptcha)
  const isDesktop = useManagement(managementSelectors.isDesktop)
  const submittedRecaptchas = useOptIn(getSubmittedRecaptchas)
  const popupId = usePage(p =>
    pageSelectors.getAscendantPopupId(p, optInButtonEntity),
  )
  const mandatoryOptInRecaptcha = usePage(p =>
    pageSelectors.getVisibleMandatoryOptInRecaptchas(p, isDesktop, popupId),
  )[0]
  const dispatch = useDispatch()
  const { t } = useTypedTranslation()

  const validateRecaptchas = () => {
    let recaptchaToken: string | undefined
    let error: string | undefined
    if (captchaOpenKey && mandatoryOptInRecaptcha) {
      const submittedRecaptcha = submittedRecaptchas.find(
        el => el.id === mandatoryOptInRecaptcha.id,
      )
      if (submittedRecaptcha) {
        recaptchaToken = submittedRecaptcha.token
      } else {
        dispatch(
          optInRecaptchaValidationFailed({
            id: mandatoryOptInRecaptcha.id,
            error: t('validation.not_empty'),
          }),
        )
        error = CAPTCHA_EMPTY_FIELD_ERROR
      }
    }
    return { recaptchaToken, error }
  }

  return { validateRecaptchas }
}
